import { Category } from '@interfaces/Category';

export class CostTypeHelper {
  public static CostTypeInternalFee = 2;
  public static CostTypeTime = 1;

  public static isExpense(costType: number) {
    return costType > CostTypeHelper.CostTypeInternalFee && costType <= 8;
  }

  public static isInternalFee(costType: number) {
    return this.CostTypeInternalFee === costType;
  }

  public static isTime(costType: number) {
    return this.CostTypeTime === costType;
  }

  public static isTimeCategory(category: Category) {
    return this.isTime(category?.costType);
  }

  public static isInternalFeeCategory(category: Category) {
    return this.isInternalFee(category?.costType);
  }

  public static isExpenseCategory(category: Category) {
    return this.isExpense(category?.costType);
  }
}
